import { useSelector } from "react-redux";

// Original hook - returns entire lobby object (causes performance issues)
export default function useLobby(key) {
  try {
    const lobbyData = useSelector((state) =>
      key ? state.lobby[key] : state.lobby
    );

    if (!lobbyData) {
      console.warn(`[useLobby] Missing data at lobby${key ? ` for key: ${key}` : ''}`);
      return {};
    }

    return lobbyData;
  } catch (error) {
    console.error(`[useLobby] Error accessing lobby data${key ? ` for key: ${key}` : ''}:`, error);
    return {};
  }
}

// Optimized hooks for specific values - prevents unnecessary re-renders
export function useLobbyValue(selector) {
  try {
    return useSelector(selector);
  } catch (error) {
    console.error(`[useLobbyValue] Error accessing lobby data:`, error);
    return undefined;
  }
}

// Specific hooks for commonly used values
export function usePlayer() {
  try {
    return useLobbyValue((state) => state.lobby.player);
  } catch (error) {
    console.error(`[usePlayer] Error accessing player data:`, error);
    return undefined;
  }
}

export function usePlayerBalance() {
  try {
    return useLobbyValue((state) => state.lobby.balance);
  } catch (error) {
    console.error(`[usePlayerBalance] Error accessing balance data:`, error);
    return undefined;
  }
}

export function useChannel() {
  try {
    return useLobbyValue((state) => state.lobby.channel);
  } catch (error) {
    console.error(`[useChannel] Error accessing channel data:`, error);
    return undefined;
  }
}

export function useAccessToken() {
  try {
    return useLobbyValue((state) => state.lobby.accessToken);
  } catch (error) {
    console.error(`[useAccessToken] Error accessing accessToken:`, error);
    return undefined;
  }
}

export function useA23Token() {
  try {
    return useLobbyValue((state) => state.lobby.a23Token);
  } catch (error) {
    console.error(`[useA23Token] Error accessing a23Token:`, error);
    return undefined;
  }
}

export function useDisplayName() {
  try {
    return useLobbyValue((state) => state.lobby.displayName);
  } catch (error) {
    console.error(`[useDisplayName] Error accessing displayName:`, error);
    return undefined;
  }
}

export function useBalance() {
  try {
    return useLobbyValue((state) => state.lobby.balance);
  } catch (error) {
    console.error(`[useBalance] Error accessing balance data:`, error);
    return undefined;
  }
}

export function useTotalBalance() {
  try {
    return useLobbyValue((state) => state.lobby.balance?.totalBalance);
  } catch (error) {
    console.error(`[useTotalBalance] Error accessing totalBalance:`, error);
    return undefined;
  }
}

export function useMasterRoomsObject() {
  try {
    return useLobbyValue((state) => state.lobby.masterRoomsObject);
  } catch (error) {
    console.error(`[useMasterRoomsObject] Error accessing masterRoomsObject:`, error);
    return undefined;
  }
}

export function useFavouriteTablesArray() {
  try {
    return useLobbyValue((state) => state.lobby.favouriteTablesArray);
  } catch (error) {
    console.error(`[useFavouriteTablesArray] Error accessing favouriteTablesArray:`, error);
    return undefined;
  }
}

export function useMasterGameDefinitions() {
  try {
    return useLobbyValue((state) => state.lobby.masterGameDefinitions);
  } catch (error) {
    console.error(`[useMasterGameDefinitions] Error accessing masterGameDefinitions:`, error);
    return undefined;
  }
}

export function useCashLobbyFilterSortConfig() {
  try {
    return useLobbyValue((state) => state.lobby.cashLobbyFilterSortConfig);
  } catch (error) {
    console.error(`[useCashLobbyFilterSortConfig] Error accessing cashLobbyFilterSortConfig:`, error);
    return undefined;
  }
}

export function useInitialSortFilterComplete() {
  try {
    return useLobbyValue((state) => state.lobby.initialSortFilterComplete);
  } catch (error) {
    console.error(`[useInitialSortFilterComplete] Error accessing initialSortFilterComplete:`, error);
    return undefined;
  }
}

export function useReceivedLobbyData() {
  try {
    return useLobbyValue((state) => state.lobby.receivedLobbyData);
  } catch (error) {
    console.error(`[useReceivedLobbyData] Error accessing receivedLobbyData:`, error);
    return undefined;
  }
}

export function useLackGames() {
  try {
    return useLobbyValue((state) => state.lobby.lackGames);
  } catch (error) {
    console.error(`[useLackGames] Error accessing lackGames:`, error);
    return undefined;
  }
}

export function useLackTourneys() {
  try {
    return useLobbyValue((state) => state.lobby.lackTourneys);
  } catch (error) {
    console.error(`[useLackTourneys] Error accessing lackTourneys:`, error);
    return undefined;
  }
}
